import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { formatNumber } from 'shared/utils';
import { Modal, Button } from 'src/components/design-system';
import styles from './check-in.module.scss';

function openDurationMinutes(openedAt, closedAt) {
  if (!openedAt || !closedAt) return null;
  const ms = new Date(closedAt).getTime() - new Date(openedAt).getTime();
  if (Number.isNaN(ms)) return null;
  return Math.max(1, Math.round(ms / 60000));
}

export function CheckInClosedModal({ open, summary, onClose }) {
  const lang = useSelector(getLang('CHECK_IN_CLOSED'));
  const minutes = summary ? openDurationMinutes(summary.openedAt, summary.closedAt) : null;

  const stats = summary
    ? [
        { key: 'total', label: lang.TOTAL, value: summary.totalCheckIns },
        { key: 'inPerson', label: lang.IN_PERSON, value: summary.inPersonCount },
        { key: 'virtual', label: lang.VIRTUAL, value: summary.virtualCount },
      ]
    : [];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={lang.HEADER}
      width={420}
      closable={false}
      footer={
        <div className={styles.closedFooter}>
          <Button type="primary" onClick={onClose}>
            {lang.DONE}
          </Button>
        </div>
      }>
      {minutes != null && (
        <p className={styles.closedDuration}>
          {lang.OPEN_DURATION.replace('{minutes}', formatNumber(minutes))}
        </p>
      )}
      <div className={styles.statsRow}>
        {stats.map(stat => (
          <div key={stat.key} className={styles.stat}>
            <span className={styles.statValue}>{formatNumber(stat.value ?? 0)}</span>
            <span className={styles.statLabel}>{stat.label}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
}
